'use strict';

var _ = require('lodash');
var ContributingFBCsGridService = function ContributingFBCsGridService(configurationService, overridesKeyService, overridesSaveService, scenarioConstants) {
  var domain = 'Fare';
  function parseData(field, value, row) {
    var overrideKey = overridesKeyService.buildOverrideKey(domain, row);
    return _.extend({
      field: field,
      type: 'O',
      value: value
    }, overrideKey);
  }
  function removeDuplicatedOperations(overrides) {
    var groupByField = _.groupBy(overrides, 'field');
    var overridesByTraffic = _.uniqWith(groupByField.traffic, function (a, b) {
      return _.isEqual(a.fareId, b.fareId) && _.isEqual(a.faresSPOS, b.faresSPOS) && _.isEqual(a.fareDirectionIndicator, b.fareDirectionIndicator);
    });
    return _.concat(overridesByTraffic);
  }
  function save(data) {
    var overrides = [];
    _.forEach(data, function (row) {
      if (row.userTraffic !== row._old.userTraffic) {
        row.userTraffic = isNaN(row.userTraffic) ? 0 : row.userTraffic;
        overrides.push(parseData('traffic', row.userTraffic, row));
      }
    });
    overrides = removeDuplicatedOperations(overrides);
    return overridesSaveService.putOverrides(domain, {
      userId: configurationService.getUserId(),
      scenario: scenarioConstants.PUBLISHED,
      overrides: overrides
    });
  }
  return {
    save: save
  };
};
ContributingFBCsGridService.$inject = ['ConfigurationService', 'OverridesKeyService', 'OverridesSaveService', 'ScenarioConstants'];
module.exports = ContributingFBCsGridService;